import Navbar from "../Navbar/Navbar";
import styles from "./HeaderWrapper.module.scss";

export default function HeaderWrapper({
    allowedRoutes,
    children,
}: {
    allowedRoutes: Set<string>;
    children: JSX.Element;
}) {
    return (
        <div className={styles.layoutContainer}>
            <Navbar allowedRoutes={allowedRoutes} />
            <div>{children}</div>
        </div>
    );
}
